import React, { useContext } from "react";
import PropTypes from "prop-types";

import { Title } from "rbx";

import { useApolloClient } from "react-apollo";
import { ModalContext } from "../ModalProvider";

import ActionButtons from "./ActionButtons";
import { useIsDispatcher } from "../../hooks";

const PageHeader = ({
  actionsType,
  title,
  name,
  editing,
  FilterComponent,
  filters,
  setFilters,
  resetFilters,
  onAddClick,
  onEditClick,
  onSaveClick,
  query,
  subheader,
  showActions,
  columns,
  where,
  readOnly,
  children,
  orderByMulti = []
}) => {
  const { setModalOpen } = useContext(ModalContext);
  const client = useApolloClient();
  const isDispatcher = useIsDispatcher();
  return (
    <header className="page-head">
      <div className="page-head-start">
        <Title color="primary" size={subheader ? 4 : 3}>
          {title}
        </Title>
      </div>
      {showActions && (
        <ActionButtons
          FilterComponent={FilterComponent}
          client={client}
          columns={columns}
          editing={editing}
          filters={filters}
          isDispatcher={isDispatcher}
          name={name}
          orderByMulti={orderByMulti}
          query={query}
          readOnly={readOnly}
          resetFilters={resetFilters}
          setFilters={setFilters}
          setModalOpen={setModalOpen}
          size="small"
          type={actionsType}
          where={where}
          onAddClick={onAddClick}
          onEditClick={onEditClick}
          onSaveClick={onSaveClick}
        >
          {children}
        </ActionButtons>
      )}
    </header>
  );
};

PageHeader.propTypes = {
  subheader: PropTypes.bool,
  title: PropTypes.string,
  FilterComponent: PropTypes.node,
  filters: PropTypes.object,
  setFilters: PropTypes.func,
  resetFilters: PropTypes.func,
  onEditClick: PropTypes.func,
  onSaveClick: PropTypes.func,
  query: PropTypes.object,
  name: PropTypes.string,
  onAddClick: PropTypes.func,
  showActions: PropTypes.bool,
  editing: PropTypes.bool,
  columns: PropTypes.array,
  actionsType: PropTypes.string,
  where: PropTypes.object,
  readOnly: PropTypes.bool,
  children: PropTypes.node,
  orderByMulti: PropTypes.array
};

PageHeader.defaultProps = {
  actionsType: "list",
  subheader: false,
  showActions: true
};
export default PageHeader;
